var translations = {
  warnings: {
    straightRow: 'Teclas consecutivas en tu teclado son fáciles de adivinar.',
    keyPattern: 'Patrones cortos son fáciles de adivinar.',
    simpleRepeat: 'Caracteres repetidos como "aaa" son fáciles de adivinar',
    extendedRepeat: 'Patrones repetidos como "abcabcabc" son fáciles de adivinar.',
    sequences: 'Patrones comunes como "abc" son fáciles de adivinar',
    recentYears: 'Los años recientes son fáciles de adivinar.',
    dates: 'Las fechas son fáciles de adivinar.',
    topTen: 'Es de las contraseñas más usadas.',
    topHundred: 'Es una contraseña usada con mucha frecuencia.',
    common: 'Es una contraseña usada comúnmente.',
    similarToCommon: 'Es similar a una contraseña usada habitualmente.',
    wordByItself: 'Palabras únicas son fáciles de adivinar.',
    namesByThemselves: 'Nombres o apellidos a solas son fáciles de adivinar.',
    commonNames: 'Nombre y apellidos comunes son fáciles de adivinar.',
    userInputs: 'No debería haber datos personales o relacionados con esta página.',
    pwned: 'Su contraseña fue expuesta por una violación de datos en Internet.'
  },
  suggestions: {
    l33t: "Evita sustituciones predecibles como '@' por '@'",
    reverseWords: 'Evita palabras comunes escritas al revés',
    allUppercase: 'Escribe en mayúsculas algunas, pero no todas las letras.',
    capitalization: 'Escribe en mayúsculas alguna letra más además de la primera.',
    dates: 'Evita fechas que estén asociadas contigo.',
    recentYears: 'Evita años recientes.',
    associatedYears: 'Evita años asociados contigo.',
    sequences: 'Evita secuencias de letras comunes.',
    repeated: 'Evitas palabras y letras repetidas.',
    longerKeyboardPattern: 'Usa patrones de teclado más largos y cambia la dirección de escritura varias veces.',
    anotherWord: 'Añade más palabras que sean menos comunes.',
    useWords: 'Usa varias palabras, pero evita frases comunes.',
    noNeed: 'Puedes crear contraseñas seguras sin usar símbolos, números o mayúsculas.',
    pwned: 'Si utiliza esta contraseña en otro lugar, debería cambiarla.'
  },
  timeEstimation: {
    ltSecond: 'menos de un segundo',
    second: '{base} segundo',
    seconds: '{base} segundos',
    minute: '{base} minuto',
    minutes: '{base} minutos',
    hour: '{base} hora',
    hours: '{base} horas',
    day: '{base} día',
    days: '{base} días',
    month: '{base} mes',
    months: '{base} meses',
    year: '{base} año',
    years: '{base} años',
    centuries: 'siglos'
  }
};

export { translations as default };
//# sourceMappingURL=translations.esm.js.map
